<span [className]="getMembershipStatusColorClass(status)">
  {{ getCustomerMembershipStatusDisplay(status) }}
  <span *ngIf="isPendingStaffApproval" class="text-warning">- Pending Approval</span>
</span>
